import React, {useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import AdminDashboard from "./admindashboard";
import FamilyAppointments from "./familyAppointments";
import FamilyProfile from "./familyProfile";
import { Tab, Tabs } from "react-bootstrap";
 
  function FamilyProfileTab() {

  const [activeTab, setActiveTab] = useState('profile');
  const userRole = JSON.parse(localStorage.getItem("data")).role;
  return (
     <div>
      <AdminDashboard />

<div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <Tabs
              id="family-profile-tabs"
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
              className="mb-3"
            >
              <Tab eventKey="profile" title="Family Profile">
              {activeTab === 'profile' && (
                <FamilyProfile/>
              )}
              </Tab>
     {userRole === "ROLE_EMPLOYEE" && (
  <Tab eventKey="appointments" title="Appointments">
    {activeTab === "appointments" && <FamilyAppointments />}
  </Tab>
)}

            </Tabs>
          </div>
        </div>
      </div>
    </div>
   
  );
}
 
export default FamilyProfileTab;